import React from 'react'
import { isBlankHtml } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { useChannelContext } from '../Channel'

type ComposerAddNoteButtonProps = {
  onClick: () => void
  isBusy: boolean
  // The caller owns the width: a mode switch must not move the toolbar slot's edge, and the
  // public control it swaps with differs per mount.
  className: string
}

// The warning "Add note" control. The save is the caller's: this renders the shared look and the
// draft/busy gating, so the note path never goes through the channel's send, which mails first
// and persists after.
export const ComposerAddNoteButton = ({ onClick, isBusy, className }: ComposerAddNoteButtonProps) => {
  const { chatId, message, status } = useChannelContext()

  return (
    <BusyButton
      onClick={onClick}
      title="Save the note — it reaches nobody outside the business."
      busyText="Saving..."
      isBusy={isBusy}
      disabled={status?.busy || isBlankHtml(message) || !chatId}
      text="Add note"
      variant="warning"
      className={className}
    />
  )
}
